// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bho_ss","PhotoTitleEditForm__cancelBtn":"iy_b bho_sw bho_sv"};